import React from "react";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ChimeChat from "components/ChimeChat";
import { X, ChatsCircle } from "@phosphor-icons/react";
import { Divider } from "@mui/material";

const ChatDrawer = ({
  user,
  chatOpen,
  toggleChatDrawer,
  messagingSession,
  customerDetails,
  clientId,
}) => {
  let designatedCaregiverCognitoId;
  if (customerDetails?.details?.document_signer_cognito_id) {
    designatedCaregiverCognitoId = customerDetails.details.document_signer_cognito_id;
  }

  return (
    <Drawer
      anchor="right"
      open={chatOpen}
      ModalProps={{
        BackdropProps: {
          sx: {
            backgroundColor: "transparent", // still clickable but not visible
          },
        },
      }}
      onClose={toggleChatDrawer}
      PaperProps={{ sx: { width: 360 } }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "24px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 3,
          }}
        >
          <ChatsCircle color="rgba(108, 116, 137, 1)" size={24} weight="duotone" />
          <Typography variant="h3">Live Chat</Typography>
        </Box>
        <IconButton onClick={toggleChatDrawer} aria-label="Close">
          <X size={20} color="rgba(76, 80, 92, 1)" />
        </IconButton>
      </Box>
      <Divider />
      <Box sx={{ flexGrow: 1, overflow: "hidden" }}>
        <ChimeChat
          messagingSession={messagingSession}
          user={user}
          designatedCaregiverCognitoId={designatedCaregiverCognitoId}
          clientId={clientId}
          chatOpen={chatOpen}
        />
      </Box>
    </Drawer>
  );
};

export default ChatDrawer;
